export enum FeedbackOptions {
  Happy = 'happy',
  Average = 'average',
  Unhappy = 'unhappy',
}
